module.exports = __webpack_public_path__ + "static/098_altana_anagl-bd5fe4d0a1ee7928714bf338b220d75e.jpg";